

/**
 * Returns whether the app is currently running on the "development"
 * environment or not.
 *
 * @returns isDev
 */
function isDev(): boolean {
	return process.env.NODE_ENV === "production";
}

/**
 * Checks if a specific feature is enabled for a given project.
 *
 * @param feature - The feature to check.
 * @param projectId - The ID of the project.
 * @returns A boolean indicating whether the feature is enabled for the project.
 */


const AppUtil = {
	isDev,
};

export default AppUtil;
